import app from 'flarum/forum/app';
import { confirmAsync } from '../../common/components/confirmAsync';
import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import { cartStore } from '../../common/utils/cartStore';
import { formatMoney } from '../../common/utils/currency';
import { productUrl } from '../../common/utils/productUrl';
import { mpImage } from '../../common/utils/mpImage';
export default class CartDropdown extends Dropdown {
  static initAttrs(attrs) {
    attrs.className = classList('CartDropdown HeaderDropdown', attrs.className);
    attrs.buttonClassName ||= 'Button Button--flat';
    attrs.menuClassName ||= 'Dropdown-menu--right MarketplaceCartDropdown-menu';
    attrs.icon ||= 'fas fa-shopping-cart';
    attrs.label ||= extractText(app.translator.trans('ramon-marketplace.forum.cart.tooltip'));
    attrs.accessibleToggleLabel ||= extractText(app.translator.trans('ramon-marketplace.forum.cart.tooltip'));
    super.initAttrs(attrs);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.unsub = cartStore.subscribe(() => m.redraw());
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.unsub?.();
  }
  getButton(children) {
    const vdom = super.getButton(children);
    vdom.attrs.title = this.attrs.label;
    vdom.attrs.onclick = this.onclick.bind(this);
    const unread = cartStore.getUnread();
    vdom.attrs.className = classList(vdom.attrs.className, unread > 0 && 'new');
    return vdom;
  }
  getButtonContent() {
    const count = cartStore.get().totals.count || 0;
    // Sem `key` de propósito: o Dropdown.getButton() do core mescla este conteúdo
    // com nós próprios (caret etc.) SEM key no mesmo fragment. Adicionar key
    // aqui mistura keyed/unkeyed e faz o Mithril lançar "vnodes must either all
    // have keys or none have keys". Por isso a regra jsx-key é desligada neste
    // bloco — são irmãos estáticos, não uma lista dinâmica.
    /* eslint-disable react/jsx-key */
    return [m(Icon, {
      name: this.attrs.icon,
      className: "Button-icon"
    }), count > 0 && m("span", {
      className: "Bubble HeaderDropdownBubble",
      "data-digits": String(count).length
    }, count), m("span", {
      className: "Button-label"
    }, m("span", {
      className: "Button-labelText"
    }, this.attrs.label))];
    /* eslint-enable react/jsx-key */
  }
  getMenu() {
    return m("div", {
      className: classList('Dropdown-menu', this.attrs.menuClassName)
    }, this.showing && this.getContent());
  }
  onclick() {
    if (app.drawer?.isOpen?.()) {
      m.route.set(app.route('marketplace.cart'));
    } else {
      cartStore.markSeen();
      // Refresh do dropdown — falha aqui só mantém estado anterior, sem
      // travar UI. Loga mesmo assim (era erro fantasma antes).
      cartStore.load().catch(e => console.warn('[marketplace cart dropdown refresh]', e));
    }
  }
  t(k, vars) {
    return app.translator.trans('ramon-marketplace.forum.' + k, vars);
  }
  async confirmClear() {
    const ok = await confirmAsync({
      title: this.t('cart.confirm_clear_title') || 'Esvaziar carrinho',
      message: this.t('cart.confirm_clear'),
      confirmLabel: this.t('cart.confirm_clear_action') || 'Esvaziar',
      danger: true
    });
    if (!ok) return;
    try {
      await cartStore.clear();
      app.alerts.show({
        type: 'success'
      }, this.t('cart.cleared'));
    } catch {
      app.alerts.show({
        type: 'error'
      }, this.t('cart.clear_error'));
    }
  }
  getContent() {
    const state = cartStore.get();
    const {
      items,
      totals
    } = state;
    return m("div", {
      className: "MarketplaceCartDropdown"
    }, m("header", {
      className: "MarketplaceCartDropdown-head"
    }, m("strong", null, this.t('cart.title')), m("div", {
      className: "MarketplaceCartDropdown-headMeta"
    }, m("span", null, totals.count, " ", totals.count === 1 ? this.t('cart.item_one') : this.t('cart.item_many')), items.length > 0 && m("button", {
      type: "button",
      className: "MarketplaceCartDropdown-clear",
      title: this.t('cart.clear'),
      onclick: e => {
        e.stopPropagation();
        e.preventDefault();
        this.confirmClear();
      }
    }, m("i", {
      className: "fas fa-trash-alt"
    })))), items.length === 0 ? m("div", {
      className: "MarketplaceCartDropdown-empty"
    }, m("i", {
      className: "fas fa-shopping-cart"
    }), m("p", null, this.t('cart.empty')), m("a", {
      href: app.route('marketplace.shop'),
      config: m.route.link,
      className: "MpBtn MpBtn--primary MpBtn--block"
    }, this.t('cart.go_shop'))) : m('[', null, m("ul", {
      className: "MarketplaceCartDropdown-items"
    }, items.map(it => m("li", {
      key: it.id
    }, m("div", {
      className: "thumb"
    }, it.product?.image ? m("img", Object.assign({}, mpImage(it.product.image), {
      alt: "",
      loading: "lazy"
    })) : m("i", {
      className: `fas ${it.product?.type === 'digital' ? 'fa-cloud-download-alt' : 'fa-box'}`
    })), m("div", {
      className: "info"
    }, m("a", {
      className: "name",
      href: it.product ? productUrl(it.product) : '',
      config: it.product ? m.route.link : null
    }, it.product?.name ?? ''), m("span", {
      className: "qty"
    }, it.product?.is_open_source ? m('[', null, "\xD7 ", it.quantity) : m('[', null, it.quantity, " \xD7 ", formatMoney(it.product?.price ?? 0)))), m("strong", {
      className: "price"
    }, it.product?.is_open_source ? m("span", {
      style: {
        color: 'var(--mp-success)'
      }
    }, this.t('shop.free')) : m('[', null, formatMoney((it.product?.price ?? 0) * it.quantity), (it.product?.billing_cycle === 'monthly' || it.product?.billing_cycle === 'yearly') && m("small", {
      style: {
        display: 'block',
        fontSize: 10,
        color: 'var(--mp-muted)',
        fontWeight: 500
      }
    }, "/", (it.selected_cycle || it.product.billing_cycle) === 'yearly' ? this.t('shop.per_year_short') : this.t('shop.per_month_short')))), m("button", {
      type: "button",
      className: "remove",
      title: this.t('cart.remove'),
      onclick: e => {
        e.stopPropagation();
        e.preventDefault();
        cartStore.remove(it.id);
      }
    }, m("i", {
      className: "fas fa-times"
    }))))), m("footer", {
      className: "MarketplaceCartDropdown-footer"
    }, m("div", {
      className: "totals"
    }, m("span", null, this.t('cart.subtotal')), m("strong", null, formatMoney(totals.subtotal))), m("div", {
      className: "actions"
    }, m("a", {
      href: app.route('marketplace.cart'),
      config: m.route.link,
      className: "MpBtn MpBtn--outline MpBtn--small MpBtn--block"
    }, this.t('cart.view')), m("a", {
      href: app.route('marketplace.checkout'),
      config: m.route.link,
      className: "MpBtn MpBtn--primary MpBtn--small MpBtn--block"
    }, m("i", {
      className: "fas fa-lock"
    }), " ", this.t('cart.checkout'))))));
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/CartDropdown', CartDropdown);